import { AlertTriangle } from 'lucide-react';

import { SimpleTooltip } from '@/components/ui/simple-tooltip';
import i18n from '@/core/i18n';

/**
 * Warning shown next to a project/member name when any worklog beneath it holds an approved
 * duration that doesn't parse.
 *
 * It exists because the broken row is usually NOT on screen: the user types something invalid,
 * collapses the section, and would otherwise have no way to find it again — while every approve
 * action stays blocked. Resolved from the stored ancestor ids, so it shows whether or not the
 * subtree is loaded.
 */
export function InvalidApprovedInputWarningIcon() {
  return (
    <SimpleTooltip
      content={i18n.t('authenticated.timeTracking:approvals.invalidApprovedInput.aggregateTooltip')}
    >
      <span
        role="img"
        aria-label={i18n.t(
          'authenticated.timeTracking:approvals.invalidApprovedInput.aggregateAriaLabel'
        )}
        // `ml-auto` parks it at the RIGHT edge of the name cell: it flags a problem somewhere
        // below rather than describing this row, so it stays clear of the row's own identity
        // (expand chevron, empty-description warning, avatar, name).
        className="ml-auto flex shrink-0 cursor-help items-center justify-center text-destructive"
      >
        <AlertTriangle size={16} strokeWidth={2} />
      </span>
    </SimpleTooltip>
  );
}
